import {IMessageCode, MessageCode} from "@mindpath/shared";
import {ClientErrorDisplays, ErrorDisplay} from "../statics";

/**
 * The title and message to show for a code.
 *
 * A code the API sent carries its own copy: `description` is only ever set from a response body, since the
 * static codes cannot hold text. Otherwise the client supplies it -- from `ClientErrorDisplays` for the BSR
 * codes it raises, or from `inline` where the raise site passes its own -- and anything left falls back to
 * BSR0000's copy.
 */
export function resolveErrorCopy(
  code: Pick<IMessageCode, 'code' | 'title' | 'description'>,
  inline?: ErrorDisplay,
): ErrorDisplay {
  const fallback = ClientErrorDisplays[MessageCode.Unknown_Browser_Exception.code!]!;
  const client = code.code === null ? undefined : ClientErrorDisplays[code.code];
  const own = inline ?? client;

  if (code.description?.trim()) {
    const title = code.title?.trim() ? code.title : own?.title ?? fallback.title;
    return {title, message: code.description};
  }

  return own ?? fallback;
}
